<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_code"
                                     :label="$t('getapi[1287]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_name"
                                     :label="$t('getapi[1197]')"></el-table-column>
                    <el-table-column prop="order_status"
                                     :label="$t('getapi[552]')">
                        <template slot-scope="scope">
                            {{scope.row.order_status | lanchange}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person"
                                     :label="$t('getapi[1419]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time"
                                     :label="$t('getapi[1420]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_person"
                                     :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_time"
                                     :label="$t('getapi[1210]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person"
                                     :label="$t('getapi[4043]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_time"
                                     :label="$t('getapi[4044]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="currency_code"
                                     :label="$t('getapi[3108]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="tax_rate" :label="$t('getapi[1225]')"
                                     align="right"></el-table-column>
                    <el-table-column prop="tax_flag"
                                     :label="$t('getapi[1421]')">
                        <template slot-scope="scope">
                            {{scope.row.tax_flag | lanchange}}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="display: flex">
                    <el-button type="primary" size="mini" @click="audit" :disabled="!btn.audit">{{ $t('getapi[3607]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :http-request="uploadFile"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :file-list="fileList"
                            :auto-upload="true"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.imppart || dataDetail.Head.vender_code == ''">{{ $t('getapi[1433]')}}</el-button>
                    </el-upload>
                </div>

                <div style="width:940px">
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.order_no" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[143]') }}</td>
                            <td style="width:250px">
                                <el-input v-model="dataDetail.Head.remark" type="text" size="mini"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[552]') }}</td>
                            <td style="width:150px;">
                                <el-input :value="explain(dataDetail.Head.order_status)" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[3108]') }}</td>
                            <td style="width:150px;">
                                <el-input v-model="dataDetail.Head.currency_code" type="text" size="mini" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1287]') }}</td>
                            <td>
                                <routejump :urlNo="26" v-show="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.Head.vender_code"
                                        type="text"
                                        readonly

                                        size="mini"
                                        class="mcolor"
                                >
                                    <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectVender"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.vender_code" v-show="addoredit != 1" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[1197]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.vender_name" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1225]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td></td>
                            <td>
                                <el-checkbox v-model="dataDetail.Head.tax_flag" :true-label=1 :false-label=0 :readonly="true" class="readO">
                                    {{$t('getapi[1421]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="">
                    <el-tab-pane :label="$t('getapi[1435]')">
                        <div class="btnnowrap">
                            <el-button type="primary" @click="addline" size="mini" :disabled="!btn.addline">{{
                                $t('getapi[878]') }}
                            </el-button>
                            <el-button type="primary" @click="delline" size="mini" :disabled="!btn.delline">
                                {{$t('getapi[3889]') }}
                            </el-button>
                        </div>
                        <el-table :data="dataDetail.List"
                                  size="mini" border
                                  style="width: 100%;margin-top: 3px"
                                  :height="tableHeight - 185"
                                  header-row-class-name="headerclass"
                                  :row-class-name="tableRowClassName"
                                  @selection-change="handleSelectionChange"
                                  ref="singleTable">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no"
                                             :label="$t('getapi[1425]')"></el-table-column>
                            <el-table-column prop="part_code" :label="$t('getapi[112]')">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.part_code"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectPart(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="net_unit_priceold" :label="$t('getapi[1427]')"
                                             align="right"></el-table-column>
                            <el-table-column prop="net_unit_price" :label="$t('getapi[3711]')"
                                             align="right">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.net_unit_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="priceChange(scope)" v-if="dataDetail.Head.tax_flag != 1"></el-input>
                                    <span v-if="dataDetail.Head.tax_flag == 1">{{scope.row.unit_price}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="unit_priceold" :label="$t('getapi[1426]')"
                                             align="right"></el-table-column>
                            <el-table-column prop="unit_price" :label="$t('getapi[3958]')"
                                             align="right">
                                <template slot-scope="scope" >
                                    <el-input v-model="scope.row.unit_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="priceChange(scope)" v-if="dataDetail.Head.tax_flag == 1"></el-input>
                                    <span v-if="dataDetail.Head.tax_flag != 1">{{scope.row.unit_price}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="change_reason"
                                             :label="$t('getapi[1429]')">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.change_reason"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectReason(scope,1)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="pur_measure"
                                             :label="$t('getapi[1166]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1438]')">
                        <div class="btnnowrap">
                            <el-button type="primary" @click="addbatchline" size="mini" :disabled="!btn.addbatchline">{{
                                $t('getapi[878]') }}
                            </el-button>
                            <el-button type="primary" @click="delbatchline" size="mini" :disabled="!btn.delbatchline">
                                {{$t('getapi[3889]') }}
                            </el-button>
                        </div>
                        <el-table :data="dataDetail.BatchList"
                                  size="mini" border
                                  style="width: 100%;margin-top: 3px"
                                  :height="tableHeight - 185"
                                  header-row-class-name="headerclass"
                                  :row-class-name="tableRowClassNameBatch"
                                  @selection-change="handleSelectionChangeBatch"
                                  ref="singleTable2">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no"
                                             :label="$t('getapi[1425]')"></el-table-column>
                            <el-table-column prop="part_code" :label="$t('getapi[112]')">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.part_code"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectBatchPart(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="batch_floor_limit"
                                             :label="$t('getapi[1289]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="net_unit_priceold" :label="$t('getapi[1427]')"
                                             align="right"></el-table-column>
                            <el-table-column prop="net_unit_price" :label="$t('getapi[3711]')"
                                             align="right">
                                <template slot-scope="scope" >
                                    <el-input v-model="scope.row.net_unit_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="priceBatchChange(scope)" v-if="dataDetail.Head.tax_flag != 1"></el-input>
                                    <span v-if="dataDetail.Head.tax_flag == 1">{{scope.row.net_unit_price}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="unit_priceold" :label="$t('getapi[1426]')"
                                             align="right"></el-table-column>
                            <el-table-column prop="unit_price" :label="$t('getapi[3958]')"
                                             align="right">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.unit_price" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="priceBatchChange(scope)" v-if="dataDetail.Head.tax_flag == 1"></el-input>
                                    <span v-if="dataDetail.Head.tax_flag != 1">{{scope.row.net_unit_price}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="change_reason"
                                             :label="$t('getapi[1429]')">
                                <template slot-scope="scope">
                                    <el-input
                                            v-model="scope.row.change_reason"
                                            type="text"
                                            readonly
                                            size="mini"
                                            class="mcolor"
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectReason(scope,2)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="pur_measure"
                                             :label="$t('getapi[1166]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{ $t('getapi[1419]')}}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.Head.create_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[733]')}}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.Head.modify_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{ $t('getapi[4043]')}}</td>
                            <td style="width:150px">
                                <el-input v-model="dataDetail.Head.audit_person" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1420]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1210]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.modify_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[4044]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.audit_time" type="datetime" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurReceiveViewInfo" ref="ser" @getser="serclick"></serce>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Sch/Quotation/GetVenderCodePopupList'" @callback="getVender" ref="vender"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Sch/Quotation/GetLinePartCodePopupList'" @callback="getPart" ref="part"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Sch/Quotation/GetBatchLinePartCodePopupList'" @callback="getBatchPart" ref="batchpart"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Sch/Quotation/GetLineSelReasonPopupList'" @callback="getReason" ref="reason"></selector>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'schqtchangelineview',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('schqtchangelineview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                order_no: '',//单据号
                currentRow: null, // 当前选中行
                dataDetail: {
                    Head: {},
                    List: [],
                    BatchList: []
                }, // 编辑页面数据详情
                oldDataDetail: '',
                selectData: [],
                selectDataBatch: [],
                oneormore: 1,
                rowindex: -1,
                batchrowindex: -1,
                addoredit: -1, // 1.新增2：编辑
                btn: {
                    audit: false,
                    imppart: false,
                    addline: false,
                    delline: false,
                    addbatchline: false,
                    delbatchline: false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                uploadurl: '',
                fileList: [],
                file: null,
                reasontype:0,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        created: function () {
            let that = this;
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('schqtchangelineview', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })

        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameBatch({row, rowIndex}) {
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[92]"),this.$t("getapi[17]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if (!this.$limits.menuvisible("plv2", 49, 1)) {
                    var value = that.$limits.newOperationAuthorityView('plv2', 48, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 49, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 49, 1) == 2) {
                        if (that.$limits.authority('plv3', 49, 1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 49, 1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 49, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if (that.dataDetail.Head.order_status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }

                                if (that.dataDetail.Head.order_status == 0) {
                                    that.$refs.SetBtn.SetOneBtnEnable('del', true);
                                }
                                else {
                                    that.$refs.SetBtn.SetOneBtnEnable('del', false);
                                }

                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.audit = false
                if(that.$limits.authority('plv4', 379, 1) == 1 && that.dataDetail.Head.order_status == 0 && !that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                    that.btn.audit = true
                }
                that.btn.imppart = false
                if(that.$limits.authority('plv2', 49, 1) == 2){
                    if(that.$limits.authority('plv3', 49, 1) > 0 && that.dataDetail.Head.order_status == 0){
                        that.btn.imppart = true
                    }
                }
                that.btn.addline = false
                that.btn.delline = false
                that.btn.addbatchline = false
                that.btn.delbatchline = false
                if(that.$limits.authority('plv4', 380, 1) == 1 && that.dataDetail.Head.order_status == 0){
                    that.btn.addline = true
                    that.btn.addbatchline = true
                    if(that.selectData.length > 0){
                        that.btn.delline = true
                    }
                    if(that.selectDataBatch.length > 0){
                        that.btn.delbatchline = true
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('schqtchangelineview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurReceiveViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Sch/Quotation/GetQuotationChangeHeadView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail;
                    for (let i = 0; i < datacopy.List.length; i++) {
                        delete datacopy.List[i].index;
                    }
                    for (let i = 0; i < datacopy.BatchList.length; i++) {
                        delete datacopy.BatchList[i].index;
                    }
                    if (that.oldDataDetail != JSON.stringify(datacopy)) {
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.order_no = row.order_no;
                                that.getDetail(that.order_no);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.order_no = row.order_no;
                        that.getDetail(that.order_no);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(order_no) {
                let that = this;
                that.addoredit = 2;
                let parm = {
                    Code: order_no
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Sch/Quotation/GetSchQuotationChangeInfoBySoCode', parm, function (res) {
                    if (res.Success == 1) {
                        that.order_no=order_no;
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority();
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.List.length; i++) {
                    delete datacopy.List[i].index;
                }
                for (let i = 0; i < datacopy.BatchList.length; i++) {
                    delete datacopy.BatchList[i].index;
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime();
                that.addoredit = 1;
                that.order_no = ''
                that.dataDetail = {
                    Head: {
                        order_no: '',
                        create_person: '',
                        create_time: '',
                        modify_person: '',
                        modify_time: '',
                        audit_person: '',
                        audit_time: '',
                        order_status: 0,
                        order_statusname: '生成',
                        vender_code: '',
                        vender_name: '',
                        remark: "",
                        currency_code: 'CNY',
                        tax_rate: '',
                        tax_flag: ''
                    },
                    List: [],
                    BatchList: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.List.length; i++) {
                    delete datacopy.List[i].index;
                }
                for (let i = 0; i < datacopy.BatchList.length; i++) {
                    delete datacopy.BatchList[i].index;
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if (that.addoredit != 1) {
                                that.getView();
                                if (!that.$limits.fnIsEmpty(that.order_no)) {
                                    that.getDetail(that.order_no)
                                }
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if (that.addoredit != 1) {
                        that.getView();
                        if (!that.$limits.fnIsEmpty(that.order_no)) {
                             that.getDetail(that.order_no)
                        }
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[1148]')
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Sch/Quotation/GetQuotationChangeHeadViewToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectVender() {
                let that = this;
                that.$refs.vender.clearInput(true);
            },
            getVender(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Head.vender_code = val.vender_code;
                that.dataDetail.Head.vender_name = val.vender_name;
                that.dataDetail.Head.tax_rate = val.tax_rate
                that.dataDetail.Head.tax_flag = val.tax_flag == true?1:0
            },
            addline() {
                let that = this
                if(that.dataDetail.Head.vender_code == ''){
                    that.$message.warning(that.$t('getapi[1366]'))//请输入供应商编码
                    return false
                }
                that.oneormore = 1
                let param = {
                    vender_code: that.dataDetail.Head.vender_code
                }
                that.$refs.part.clearInput(true,param);
            },
            selectPart(row) {
                let that = this;
                if(that.dataDetail.Head.vender_code == ''){
                    that.$message.warning(that.$t('getapi[1366]'))//请输入供应商编码
                    return false
                }
                that.oneormore = 2
                let param = {
                    vender_code: that.dataDetail.Head.vender_code
                }
                that.rowindex = row.$index
                that.$refs.part.clearInput(true,param);
            },
            getPart(val) {
                let that = this;
                console.log(val)
                for(let i = 0;i<that.dataDetail.List.length;i++){
                    if(val.part_code + val.part_version == that.dataDetail.List[i].part_code + that.dataDetail.List[i].part_version){
                        return
                    }
                }
                let dataDetailLineNo = 1
                for (let i = 0; i < that.dataDetail.List.length; i++) {
                    if (that.dataDetail.List[i].line_no >= dataDetailLineNo) {
                        dataDetailLineNo = that.dataDetail.List[i].line_no + 1
                    }
                }
                if (that.oneormore == 1) {
                    that.dataDetail.List = [...that.dataDetail.List,{
                        relation_order_no: that.dataDetail.Head.order_no,
                        line_no: dataDetailLineNo,
                        part_code: val.part_code,
                        part_version: val.part_version,
                        net_unit_price: '',
                        unit_price: '',
                        net_unit_priceold: val.net_unit_price,
                        unit_priceold: val.unit_price,
                        change_type_flag: '',
                        change_reason: '',
                        pur_measure: val.pur_measurementunit,
                        isadd:1
                    }]
                } else {
                    that.dataDetail.List[that.rowindex].part_code = val.part_code;
                    that.dataDetail.List[that.rowindex].part_version = val.part_version;
                    that.dataDetail.List[that.rowindex].net_unit_price = val.net_unit_price;
                    that.dataDetail.List[that.rowindex].unit_price = val.unit_price;
                    that.dataDetail.List[that.rowindex].pur_measure = val.pur_measurementunit;
                }
            },
            delline() {
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no:that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            List: []
                        }
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.List.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].isadd != 1){
                                parm.List.push({
                                    line_no:that.selectData[i].line_no
                                })
                            }
                        }
                        if(parm.List.length != 0){
                            that.$http.urlpost('/Sch/Quotation/DelSchQuotationChangeLine', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.order_no != '') {
                                        that.getDetail(that.order_no);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            addbatchline() {
                let that = this
                if(that.dataDetail.Head.vender_code == ''){
                    that.$message.warning(that.$t('getapi[1366]'))//请输入供应商编码
                    return false
                }
                that.oneormore = 1
                let param = {
                    vender_code: that.dataDetail.Head.vender_code
                }
                that.$refs.batchpart.clearInput(true,param);
            },
            selectBatchPart(row) {
                let that = this;
                if(that.dataDetail.Head.vender_code == ''){
                    that.$message.warning(that.$t('getapi[1366]'))//请输入供应商编码
                    return false
                }
                that.oneormore = 2
                let param = {
                    vender_code: that.dataDetail.Head.vender_code
                }
                that.batchrowindex = row.$index
                that.$refs.batchpart.clearInput(true,param);
            },
            getBatchPart(val) {
                let that = this;
                for(let i = 0;i<that.dataDetail.BatchList.length;i++){
                    if(val.part_code + val.part_version == that.dataDetail.BatchList[i].part_code + that.dataDetail.BatchList[i].part_version){
                        return
                    }
                }
                let dataDetailLineNo = 1
                for (let i = 0; i < that.dataDetail.BatchList.length; i++) {
                    if (that.dataDetail.BatchList[i].line_no >= dataDetailLineNo) {
                        dataDetailLineNo = that.dataDetail.BatchList[i].line_no + 1
                    }
                }
                if (that.oneormore == 1) {
                    that.dataDetail.BatchList = [...that.dataDetail.BatchList,{
                        relation_order_no: that.dataDetail.Head.order_no,
                        line_no: dataDetailLineNo,
                        part_code: val.part_code,
                        part_version: val.part_version,
                        batch_floor_limit: '',
                        net_unit_price: '',
                        unit_price: '',
                        net_unit_priceold: val.net_price,
                        unit_priceold: val.price,
                        change_type_flag: '',
                        change_reason: '',
                        pur_measure: val.pur_measurementunit,
                    }]
                } else {
                    that.dataDetail.BatchList[that.batchrowindex].part_code = val.part_code;
                    that.dataDetail.BatchList[that.batchrowindex].part_version = val.part_version;
                    that.dataDetail.BatchList[that.batchrowindex].net_unit_price = val.net_unit_price;
                    that.dataDetail.BatchList[that.batchrowindex].unit_price = val.unit_price;
                    that.dataDetail.BatchList[that.batchrowindex].pur_measure = val.pur_measurementunit;
                }
            },
            delbatchline() {
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no:that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time,
                            List: []
                        }
                        
                        for (let i = that.selectDataBatch.length - 1; i >= 0; i--) {
                            that.dataDetail.BatchList.splice(that.selectDataBatch[i].index, 1);
                            if(that.selectDataBatch[i].isadd != 1){
                                parm.List.push({
                                    line_no:that.selectDataBatch[i].line_no
                                })
                            }
                        }                        
                        if(parm.List.length != 0){
                            that.$http.urlpost('/Sch/Quotation/DelSchQuotationChangeBatchLine', parm , function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.order_no != '') {
                                        that.getDetail(that.order_no);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectReason(row,reasontype) {
                let that = this;
                that.rowindex = row.$index
                that.reasontype=reasontype;
                that.$refs.reason.clearInput(true);
            },
            getReason(val) {
                let that = this;
                if(that.reasontype==1){
                    that.dataDetail.List[that.rowindex].change_reason = val.changereason;
                }
                else if(that.reasontype==2){
                    that.dataDetail.BatchList[that.rowindex].change_reason = val.changereason;
                }
            },
            // 审核
            audit(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    modify_time: that.dataDetail.Head.modify_time
                }
                that.$http.urlpost('/Sch/Quotation/SchQuotationChangeAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.order_no)
                    }
                });
            },
            handleChange(file, fileList) {
                let that = this;
                that.file = file.raw
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            uploadFile(){
                let that = this;
                let formData = new FormData(); //formdata格式
                formData.append('file', that.file);
                formData.append('vender_code', that.dataDetail.Head.vender_code);
                formData.append('tax_flag', that.dataDetail.Head.tax_flag);
                formData.append('tax_rate', that.dataDetail.Head.tax_rate);
                that.$http.urlpost('/Sch/Quotation/SchQuotationChangeExcelIn', formData, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.List
                        let arr = data.filter(item => {
                            return that.dataDetail.List.every(item2 => {
                                return item.part_code + item.part_version != item2.part_code + item2.part_version
                            });
                        });
                        data = arr
                        let dataDetailLineNo = 1
                        for (let i = 0; i < that.dataDetail.List.length; i++) {
                            if (that.dataDetail.List[i].line_no >= dataDetailLineNo) {
                                dataDetailLineNo = that.dataDetail.List[i].line_no + 1
                            }
                        }
                        for(let i = 0;i<data.length;i++){
                            that.dataDetail.List = [...that.dataDetail.List,{
                                relation_order_no: data[i].relation_order_no,
                                line_no: dataDetailLineNo++,
                                part_code: data[i].part_code,
                                part_version: data[i].part_version,
                                net_unit_price: data[i].net_unit_price,
                                unit_price: data[i].unit_price,
                                net_unit_priceold: data[i].net_unit_priceold,
                                unit_priceold: data[i].unit_priceold,
                                change_type_flag: data[i].change_type_flag,
                                change_reason: data[i].change_reason,
                                pur_measure: data[i].pur_measure,
                                isadd:1
                            }]
                        }
                    }
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChangeBatch(val) {
                let that = this;
                that.selectDataBatch = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataBatch.push(val[i]);
                }
                that.btnauthority()
            },
            save(){
                let that = this;
                let parm = that.dataDetail;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Sch/Quotation/SaveData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(res.UniqueNum);
                    }
                });
            },
            //单据删除
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_time: that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Sch/Quotation/DelSchQuotationChange', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            priceChange(row){
                let that = this
                let index = row.$index
                if(that.dataDetail.Head.tax_flag != 1){
                    let ShuiLv = ''
                    let TPrice = ''
                    if(that.dataDetail.Head.tax_rate == ''){
                        ShuiLv = 0
                    } else {
                        ShuiLv = that.dataDetail.Head.tax_rate
                    }
                    let NetUnitPrice = ''
                    let NetUnitPriceOld = ''
                    try{
                        NetUnitPriceOld = parseFloat(that.dataDetail.List[index].net_unit_priceold)
                    } catch {
                        NetUnitPriceOld = 0
                    }
                    try{
                        NetUnitPrice = parseFloat(that.dataDetail.List[index].net_unit_price)
                    } catch {
                        NetUnitPrice = 0
                    }
                    if(NetUnitPrice > NetUnitPriceOld){
                        that.dataDetail.List[index].change_type_flag == 0
                    }
                    if(NetUnitPrice < NetUnitPriceOld){
                        that.dataDetail.List[index].change_type_flag == 1
                    }
                    if(NetUnitPrice == NetUnitPriceOld){
                        that.dataDetail.List[index].change_type_flag == -1
                    }
                    TPrice = NetUnitPrice  * (1 + (ShuiLv / 100))
                    that.dataDetail.List[index].unit_price = that.$processdata.mathRound4(TPrice)
                } else {
                    let ShuiLv = ''
                    let TPrice = ''
                    if(that.dataDetail.Head.tax_rate == ''){
                        ShuiLv = 0
                    } else {
                        ShuiLv = that.dataDetail.Head.tax_rate
                    }
                    let UnitPrice
                    let UnitPriceOld
                    try{
                        UnitPriceOld = parseFloat(that.dataDetail.List[index].unit_priceold)
                    } catch {
                        UnitPrice = 0
                    }
                    try{
                        UnitPrice = parseFloat(that.dataDetail.List[index].unit_price)
                    } catch {
                        UnitPrice = 0
                    }
                    if(UnitPrice > UnitPriceOld){
                        that.dataDetail.List[index].change_type_flag == 0
                    }
                    if(UnitPrice < UnitPriceOld){
                        that.dataDetail.List[index].change_type_flag == 1
                    }
                    if(UnitPrice == UnitPriceOld){
                        that.dataDetail.List[index].change_type_flag == -1
                    }
                    TPrice = UnitPrice / (1 + (ShuiLv / 100))
                    that.dataDetail.List[index].net_unit_price = that.$processdata.mathRound4(TPrice)
                }
            },
            priceBatchChange(row){
                let that = this
                let index = row.$index
                if(that.dataDetail.Head.tax_flag != 1){
                    let ShuiLv = ''
                    let TPrice = ''
                    if(that.dataDetail.Head.tax_rate == ''){
                        ShuiLv = 0
                    } else {
                        ShuiLv = that.dataDetail.Head.tax_rate
                    }
                    let NetUnitPrice = ''
                    let NetUnitPriceOld = ''
                    try{
                        NetUnitPriceOld = parseFloat(that.dataDetail.BatchList[index].net_unit_priceold)
                    } catch {
                        NetUnitPriceOld = 0
                    }
                    try{
                        NetUnitPrice = parseFloat(that.dataDetail.BatchList[index].net_unit_price)
                    } catch {
                        NetUnitPrice = 0
                    }
                    if(NetUnitPrice > NetUnitPriceOld){
                        that.dataDetail.BatchList[index].change_type_flag == 0
                    }
                    if(NetUnitPrice < NetUnitPriceOld){
                        that.dataDetail.BatchList[index].change_type_flag == 1
                    }
                    if(NetUnitPrice == NetUnitPriceOld){
                        that.dataDetail.BatchList[index].change_type_flag == -1
                    }
                    TPrice = NetUnitPrice  * (1 + (ShuiLv / 100))
                    that.dataDetail.BatchList[index].unit_price = that.$processdata.mathRound4(TPrice)
                } else {
                    let ShuiLv = ''
                    let TPrice = ''
                    if(that.dataDetail.Head.tax_rate == ''){
                        ShuiLv = 0
                    } else {
                        ShuiLv = that.dataDetail.Head.tax_rate
                    }
                    let UnitPrice
                    let UnitPriceOld
                    try{
                        UnitPriceOld = parseFloat(that.dataDetail.BatchList[index].unit_priceold)
                    } catch {
                        UnitPrice = 0
                    }
                    try{
                        UnitPrice = parseFloat(that.dataDetail.BatchList[index].unit_price)
                    } catch {
                        UnitPrice = 0
                    }
                    if(UnitPrice > UnitPriceOld){
                        that.dataDetail.BatchList[index].change_type_flag == 0
                    }
                    if(UnitPrice < UnitPriceOld){
                        that.dataDetail.BatchList[index].change_type_flag == 1
                    }
                    if(UnitPrice == UnitPriceOld){
                        that.dataDetail.BatchList[index].change_type_flag == -1
                    }
                    TPrice = UnitPrice / (1 + (ShuiLv / 100))
                    that.dataDetail.BatchList[index].net_unit_price = that.$processdata.mathRound4(TPrice)
                }
            },
            explain(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//生成
                } else if(val == 1){
                    return that.$t('getapi[941]')//审核
                } else {
                    return
                }
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 49,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail;
                for (let i = 0; i < datacopy.List.length; i++) {
                    delete datacopy.List[i].index;
                }
                for (let i = 0; i < datacopy.BatchList.length; i++) {
                    delete datacopy.BatchList[i].index;
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
